module.exports = __webpack_public_path__ + "static/media/S1-F1-Zartrower-codF1.0cf25227.png";